import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  .ant-select {
    .ant-select-selector {
      border-radius: 20px;
      padding: 0 20px;
    }
  }
`

export default Styled
